import React, { useState } from "react";
import { personnelApi } from "../../../api/personnelApi";

export default function ExpiringContractsWidget() {
  const [days, setDays] = useState(30);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  async function load() {
    setErr("");
    try {
      const res = await personnelApi.expiringContracts(days);
      setData(res);
    } catch (e) {
      setErr(String(e.message || e));
    }
  }

  return (
    <div className="text-end">
      <button className="btn btn-outline-primary btn-sm" onClick={() => { setOpen(!open); if (!open) load(); }}>
        Contratti in scadenza
      </button>

      {open ? (
        <div className="card mt-2 shadow-sm" style={{ minWidth: 360 }}>
          <div className="card-body">
            <div className="d-flex gap-2 align-items-center">
              <div className="small text-muted">Giorni:</div>
              <select className="form-select form-select-sm" style={{ width: 120 }}
                value={days} onChange={(e) => setDays(Number(e.target.value))}
              >
                <option value={7}>7</option>
                <option value={15}>15</option>
                <option value={30}>30</option>
                <option value={60}>60</option>
              </select>
              <button className="btn btn-sm btn-outline-secondary" onClick={load}>↻</button>
            </div>

            {err ? <div className="alert alert-danger mt-2 mb-0 small">{err}</div> : null}

            <div className="mt-2 small">
              {(data || []).length ? (
                <div className="list-group">
                  {data.map((c) => (
                    <div key={c.id} className="list-group-item">
                      <div className="fw-semibold">
                        {c.employee?.lastName} {c.employee?.firstName}
                      </div>
                      <div className="text-muted">
                        Scade: {String(c.endDate).slice(0, 10)} • {c.type}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-muted">Nessun contratto in scadenza.</div>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
